import { Traveler } from 'src/sdk-reservation';

export namespace TestData_PASSENGER {
  export const DEFAULT_TRAVELER: Required<Traveler> = {
    id: 'PASSENGER00101',
    names: [{ title: 'MR', firstName: 'TARO', lastName: 'SORANO', middleName: '' }],
    passengerTypeCode: 'ADT',
    accompanyingTravelerId: '',
    dateOfBirth: '1990/1/4',
    encryptedDateOfBirth: '',
    gender: 'M',
    regulatoryDetails: {},
    isChildMealRecommendedAge: false,
    age: '',
    encryptedAge: '',
    disabilityDiscountInfomation: { disabilityType: 'grade1' },
    isDisabilityDiscountInformationRegistered: false,
    islandCard: { number: '' },
    isIslandCardRegistered: false,
  };

  export const TRAVELER1: Required<Traveler> = { ...DEFAULT_TRAVELER };
  export const TRAVELER2: Required<Traveler> = {
    ...DEFAULT_TRAVELER,
    id: 'PASSENGER00102',
    names: [{ title: 'MS', firstName: 'SORAMI', lastName: 'SORANO', middleName: '' }],
    gender: 'F',
    accompanyingTravelerId: 'PASSENGER00201',
  };
  export const TRAVELER3: Required<Traveler> = {
    ...DEFAULT_TRAVELER,
    id: 'PASSENGER00201',
    names: [{ title: '', firstName: 'SORATARO', lastName: 'YAMANO', middleName: '' }],
    passengerTypeCode: 'INF',
  };

  export const TRAVELER4: Required<Traveler> = {
    ...DEFAULT_TRAVELER,
    id: 'PASSENGER00103',
    names: [{ title: 'MR', firstName: 'KUUKAI', lastName: 'SORAYAMA', middleName: '' }],
    passengerTypeCode: 'B15',
  };

  export const TRAVELER5: Required<Traveler> = {
    ...DEFAULT_TRAVELER,
    id: 'PASSENGER00104',
    names: [{ title: 'MSTR', firstName: 'SORASUKE', lastName: 'SORAOKA', middleName: '' }],
    passengerTypeCode: 'CHD',
    isChildMealRecommendedAge: true,
  };

  export const ARRAY_TRAVELER1: Array<Required<Traveler>> = _ARRAY_TRAVELER1();
  function _ARRAY_TRAVELER1(): Array<Required<Traveler>> {
    const ret: Array<Required<Traveler>> = [];
    for (let i = 0; i < 100; i++) {
      ret.push({
        ...DEFAULT_TRAVELER,
        id: 'PASSENGER01' + i.toString().padStart(3, '0'),
        names: [{ title: 'Mr', firstName: i.toString() + 'TARO', lastName: 'SORANO', middleName: '' }],
        passengerTypeCode: 'ADT',
      });
    }
    return ret;
  }
  export const ARRAY_TRAVELER2: Array<Required<Traveler>> = _ARRAY_TRAVELER2();
  function _ARRAY_TRAVELER2(): Array<Required<Traveler>> {
    const ret: Array<Required<Traveler>> = [];
    for (let i = 0; i < 100; i++) {
      ret.push({
        ...DEFAULT_TRAVELER,
        id: 'PASSENGER02' + i.toString().padStart(3, '0'),
        names: [{ title: 'Ms', firstName: i.toString() + 'MI', lastName: 'SORANO', middleName: '' }],
        passengerTypeCode: 'ADT',
      });
    }
    return ret;
  }

  function numbersToKanji(num: number) {
    let ret = '';
    if (num < 0) {
      ret += 'マイナス';
      num *= -1;
    }
    const kanjiNums = ['', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
    const kanjiNames = [
      '十',
      '百',
      '千',
      '万',
      '億',
      '兆',
      '京',
      '垓',
      '𥝱',
      '穣',
      '溝',
      '澗',
      '正',
      '載',
      '極',
      '恒河沙',
      '阿僧祇',
      '那由他',
      '不可思議',
      '無量大数',
    ];
    const exponents = [1, 2, 3, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60, 64, 68];
    const exponentsLen = exponents.length;
    for (let i = exponentsLen; i >= 0; --i) {
      const bias = Math.pow(10, exponents[i]);
      if (num >= bias) {
        const top = Math.floor(num / bias);
        if (top >= 10) {
          ret += numbersToKanji(top);
        } else {
          if (top == 1 && exponents[i] <= 3) {
            // ※先頭の数字が1、かつ指数が3 (千の位) 以下の場合のみ『一』をつけない
          } else {
            ret += kanjiNums[top];
          }
        }
        ret += kanjiNames[i];
        num -= top * bias;
      }
    }
    ret += kanjiNums[num];
    return ret;
  }

  //サービス申し込みモーダル用
  export const TRAVELER_R01_M51_1: Required<Traveler> = { ...DEFAULT_TRAVELER, id: 'TRAVELER_R01_M51_1' };
  export const TRAVELER_R01_M51_2: Required<Traveler> = {
    ...DEFAULT_TRAVELER,
    id: 'TRAVELER_R01_M51_2',
    names: [{ title: '', firstName: 'SORAMI', lastName: 'SORANO', middleName: '' }],
    gender: 'unspecified',
    accompanyingTravelerId: 'TRAVELER_R01_M51_3',
  };
  export const TRAVELER_R01_M51_3: Required<Traveler> = {
    ...DEFAULT_TRAVELER,
    id: 'TRAVELER_R01_M51_3',
    names: [{ title: '', firstName: 'SORATARO', lastName: 'SORANO', middleName: '' }],
    passengerTypeCode: 'INF',
  };
  export const TRAVELER_R01_M51_4: Required<Traveler> = {
    ...DEFAULT_TRAVELER,
    id: 'TRAVELER_R01_M51_4',
    names: [{ title: '', firstName: 'YAMAMI', lastName: 'YAMANO', middleName: '' }],
    gender: 'unknown',
    accompanyingTravelerId: 'TRAVELER_R01_M51_5',
  };
  export const TRAVELER_R01_M51_5: Required<Traveler> = {
    ...DEFAULT_TRAVELER,
    id: 'TRAVELER_R01_M51_5',
    names: [],
    passengerTypeCode: 'INF',
  };
  export const TRAVELER_R01_M51_6: Required<Traveler> = {
    ...DEFAULT_TRAVELER,
    id: 'TRAVELER_R01_M51_6',
    names: [{ title: 'Mr', firstName: 'UMITARO', lastName: 'UMINO', middleName: '' }],
    passengerTypeCode: 'B15',
  };
  export const TRAVELER_R01_M51_7: Required<Traveler> = {
    ...DEFAULT_TRAVELER,
    id: 'TRAVELER_R01_M51_7',
    names: [],
    passengerTypeCode: 'CHD',
  };

  export const TRAVELER_R01_M51_8: Required<Traveler> = {
    ...DEFAULT_TRAVELER,
    id: 'TRAVELER_R01_M51_8',
    names: [{ title: 'Ms', firstName: 'dolphin', lastName: 'blue', middleName: 'ocean' }],
    passengerTypeCode: 'CHD',
    isChildMealRecommendedAge: true,
    gender: 'F',
  };

  //搭乗者情報入力　遷移先モーダル用
  export const TRAVELER_R01_M60_1: Required<Traveler> = {
    ...DEFAULT_TRAVELER,
    id: 'TRAVELER_R01_M51_1',
    dateOfBirth: '1980/01/01',
  };
  export const TRAVELER_R01_M60_2: Required<Traveler> = {
    ...DEFAULT_TRAVELER,
    id: 'TRAVELER_R01_M60_2',
    names: [{ title: 'Ms', firstName: 'SORAMI', lastName: 'SORANO', middleName: '' }],
    gender: 'F',
    accompanyingTravelerId: 'TRAVELER_R01_M51_3',
    dateOfBirth: '1980/01/01',
  };
  export const TRAVELER_R01_M60_3: Required<Traveler> = {
    ...DEFAULT_TRAVELER,
    id: 'TRAVELER_R01_M60_3',
    names: [{ title: 'MR', firstName: 'SORAJIRO', lastName: 'YAMANO', middleName: 'UMI' }],
    gender: 'M',
    passengerTypeCode: 'B15',
    dateOfBirth: '2008/01/01',
  };
  export const TRAVELER_R01_M60_4: Required<Traveler> = {
    ...DEFAULT_TRAVELER,
    id: 'TRAVELER_R01_M60_4',
    names: [{ title: '', firstName: 'SORA', lastName: 'YAMANO', middleName: '' }],
    gender: 'F',
    passengerTypeCode: 'CHD',
    dateOfBirth: '2012/01/01',
  };
  export const TRAVELER_R01_M60_5: Required<Traveler> = {
    ...DEFAULT_TRAVELER,
    id: 'TRAVELER_R01_M60_5',
    names: [{ title: '', firstName: 'UMI', lastName: 'YAMANO', middleName: '' }],
    gender: 'M',
    passengerTypeCode: 'INF',
    dateOfBirth: '2023/01/01',
  };

  export const TRAVELER_R01_M60_6: Required<Traveler> = {
    ...DEFAULT_TRAVELER,
    id: 'TRAVELER_R01_M60_6',
    names: [{ title: '', firstName: '山', lastName: '海川', middleName: '' }],
    gender: 'M',
    passengerTypeCode: 'B15',
    dateOfBirth: '2012/01/01',
  };
  export const TRAVELER_R01_M60_7: Required<Traveler> = {
    ...DEFAULT_TRAVELER,
    id: 'TRAVELER_R01_M60_7',
    names: [{ title: '', firstName: '空', lastName: '海川', middleName: '' }],
    gender: 'M',
    passengerTypeCode: 'CHD',
    dateOfBirth: '2013/01/01',
  };
  export const TRAVELER_R01_M60_8: Required<Traveler> = {
    ...DEFAULT_TRAVELER,
    id: 'TRAVELER_R01_M60_8',
    names: [{ title: '', firstName: '陸', lastName: '海川', middleName: '' }],
    gender: 'M',
    passengerTypeCode: 'CHD',
    dateOfBirth: '2020/01/01',
  };
  export const TRAVELER_R01_M60_9: Required<Traveler> = {
    ...DEFAULT_TRAVELER,
    id: 'TRAVELER_R01_M60_8',
    names: [{ title: '', firstName: '森', lastName: '海川', middleName: '' }],
    gender: 'M',
    passengerTypeCode: 'INF',
    dateOfBirth: '2023/01/01',
  };

  export const TRAVELER_DISABILITY_CAREGIVER_1: Required<Traveler> = {
    ...DEFAULT_TRAVELER,
    id: 'TRAVELER_DISABILITY_CAREGIVER_1',
    names: [{ title: '', firstName: '太郎', lastName: '介助', middleName: '' }],
    gender: 'M',
    passengerTypeCode: 'ADT',
    dateOfBirth: '2000/01/01',
  };
  export const TRAVELER_DISABILITY_CAREGIVER_2: Required<Traveler> = {
    ...DEFAULT_TRAVELER,
    id: 'TRAVELER_DISABILITY_CAREGIVER_2',
    names: [{ title: '', firstName: '助太', lastName: '介助', middleName: '' }],
    gender: 'M',
    passengerTypeCode: 'ADT',
    dateOfBirth: '2000/01/01',
  };
  export const TRAVELER_DISABILITY_1: Required<Traveler> = {
    ...DEFAULT_TRAVELER,
    id: 'TRAVELER_DISABILITY_1',
    names: [{ title: '', firstName: '歩', lastName: '不可', middleName: '' }],
    gender: 'M',
    passengerTypeCode: 'ADT',
    dateOfBirth: '2000/01/01',
    disabilityDiscountInfomation: {
      disabilityType: 'caregiver',
      careReceiverTravelerId: 'TRAVELER_DISABILITY_CAREGIVER_1',
    },
  };
  export const TRAVELER_DISABILITY_2: Required<Traveler> = {
    ...DEFAULT_TRAVELER,
    id: 'TRAVELER_DISABILITY_2',
    names: [{ title: '', firstName: '寧音', lastName: '不可', middleName: '' }],
    gender: 'F',
    passengerTypeCode: 'ADT',
    dateOfBirth: '2000/01/01',
    disabilityDiscountInfomation: {
      disabilityType: 'caregiver',
      careReceiverTravelerId: 'TRAVELER_DISABILITY_CAREGIVER_1',
    },
  };
  export const TRAVELER_DISABILITY_3: Required<Traveler> = {
    ...DEFAULT_TRAVELER,
    id: 'TRAVELER_DISABILITY_3',
    names: [{ title: '', firstName: '視界', lastName: '不可', middleName: '' }],
    gender: 'M',
    passengerTypeCode: 'ADT',
    dateOfBirth: '2000/01/01',
    disabilityDiscountInfomation: {
      disabilityType: 'caregiver',
      careReceiverTravelerId: 'TRAVELER_DISABILITY_CAREGIVER_2',
    },
  };
}
